import moment from "moment";

import { func_validation } from "./func_validation";
import { func_serviceHandling } from "./func_serviceHandling";

export const func_datetime = {

    setNowToServerTime,

    getCurrentYear,
    
    convertDateTimeToUTC,
    convertUTCDateTimeToLocal,
    convertDateTimeToLocal,
    convertDateTimeToISO,

    retrieveDateTimeDifference,
    retrieveDateTimeDifferenceFromNowSinceThen,
    retrieveDateTimeDifferenceFromNowSinceThen_inDays,

    retrieveDateTimeBeforeSpecified_days,
    retrieveDateTimeAfterSpecified_days,
    retrieveDateTimeBeforeSpecified_years,
	retrieveDateTimeAfterSpecified_years,

};

function setNowToServerTime(url, cbFunc_success, cbFunc_fail) {
	func_serviceHandling.requestAjaxGetText(url)
		.then(
			(details) => {
				
				// Format server time
				let serverTime = (details)?details:+new Date();
				serverTime = parseInt(serverTime);

				// Update moment now function
				moment.now = function () { return serverTime; };
				
				if (cbFunc_success) cbFunc_success(details, serverTime);
			}, (details) => { if (cbFunc_fail) cbFunc_fail(details); }
		);
}

function getCurrentYear() {
    return moment().year();
}

function convertDateTimeToUTC(datetime_raw) {
    return moment(datetime_raw).utc();
}

function convertUTCDateTimeToLocal(datetime_utc, datetimeFormat) {
    return datetime_utc.local().format(datetimeFormat);
}

function convertDateTimeToLocal(datetime_raw, datetimeFormat) {
    return convertUTCDateTimeToLocal(convertDateTimeToUTC(datetime_raw), datetimeFormat);
}

function convertDateTimeToISO(datetime) {
    let date_formatted = datetime.setUTCHours(date_formatted.getUTCHours() + 8);
    date_formatted = date_formatted.toISOString();
    return date_formatted;
}

// Note: 
// - "start" date later than "end" result in positive
// - "end" date later than "start" date result in negative
function retrieveDateTimeDifference(datetime_raw_start, datetime_raw_end) {
    let now = moment(datetime_raw_start);
    let end = moment(datetime_raw_end);

    return moment.duration(now.diff(end));
}

function retrieveDateTimeDifferenceFromNowSinceThen(datetime_raw_end) {
    return retrieveDateTimeDifference(moment(), datetime_raw_end);
}

function retrieveDateTimeDifferenceFromNowSinceThen_inDays(datetime_raw_end) {
    return retrieveDateTimeDifference(moment(), datetime_raw_end).asDays();
}

function retrieveDateTimeBeforeSpecified_days(datetime_raw, days) {
    if (!func_validation.isNumberValid(days)) return moment(datetime_raw);
    return moment(datetime_raw).subtract(days, "days");
}

function retrieveDateTimeAfterSpecified_days(datetime_raw, days) {
    if (!func_validation.isNumberValid(days)) return moment(datetime_raw);
    return moment(datetime_raw).add(days, "days");
}

function retrieveDateTimeBeforeSpecified_years(datetime_raw, years) {
    if (!func_validation.isNumberValid(years)) return moment(datetime_raw);
    return moment(datetime_raw).subtract(years, "years");
}

function retrieveDateTimeAfterSpecified_years(datetime_raw, years) {
    if (!func_validation.isNumberValid(years)) return moment(datetime_raw);
    return moment(datetime_raw).add(years, "years");
}


